import styled from 'styled-components'
import { PRIMARY_DARK_COLOR, SELECTED_ITEM_BG_COLOR } from '@CSSVars/colors'


export const _SearchPageMobileContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  background: white;
  z-index: ${({ hideHeader }) => (hideHeader ? '10000' : '2006')};
  overflow: ${({ hideHeader }) => (hideHeader ? 'scroll' : 'visible')};
`

export const _Root = styled.div`
  width: 100%;
  height: ${({ hideHeader }) => (hideHeader ? '100vh' : 'calc(100vh - 64px)')};
  top: ${({ hideHeader }) => (hideHeader ? '0' : '64px')};
  position: absolute;
  z-index: 1006;
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 24px 16px 80px 16px;
`

export const _Close = styled.div`
  pointer-events: visible;
  position: absolute;
  top: 0;
  left: 10px;
  padding: 18px 12px;
  cursor: pointer;
  svg {
    fill: ${PRIMARY_DARK_COLOR};
  }
`

export const _Clear = styled.div`
  position: absolute;
  right: 16px;
  top: 24px;
  font-size: 12px;
  font-weight: 600;
  color: ${PRIMARY_DARK_COLOR};
  cursor: pointer;
  :active {
    color: ${SELECTED_ITEM_BG_COLOR};
  }
`
